[...document.querySelectorAll('.scroll-to')].forEach(function(element) { //makes use of ... spread operator to convert to array
  //get header height
  let header = document.getElementsByTagName('header')[0];
  //if tag name is link else loop through children (thanks gutenberg)
  if( element.tagName == 'A' ){
    element.addEventListener('click', ( e ) => {
      e.preventDefault();
      let trgt = element.getAttribute('href');
      let trgtId = trgt.replace('#', '');
      let trgtEl = document.getElementById( trgtId );
      scrollToElement( trgtEl, header.offsetHeight + 16 );
    });
  } else {
    [...element.childNodes].forEach( child => {
      if( child.tagName == 'A' ){
        child.addEventListener('click', ( e ) => {
          e.preventDefault();
          let trgt = child.getAttribute('href');
          let trgtId = trgt.replace('#', '');
          let trgtEl = document.getElementById( trgtId );
          scrollToElement( trgtEl, header.offsetHeight + 16 );
        });
      }
    })
  }
});


export function scrollToElement( trgt, offsetTop = 40 ){
  let elementCoords = trgt.getBoundingClientRect();
  let elTop = elementCoords.top;
  
  if (document.body.classList.contains('ie-browser')) {
    window.scrollTo(0, window.pageYOffset + elTop - offsetTop);
  } else {
    window.scrollTo({
      top: window.scrollY + elTop - offsetTop,
      left: 0,
      behavior: 'smooth'
    })
  }
}
